import { CheckboxTreeNode } from './checkbox-tree-node';

export class Page {
    constructor(public pageId: any, public value: CheckboxTreeNode[]) {}
}
